module.exports = __webpack_public_path__ + "img/karate_gear.c50667ee.jpg";